import {Fragment, useState} from "react";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CreateUpdateDialog from "./SaveDialog";
import {SpeedDialInput} from "../../../api";

type Props = {
    userId: number;
    data: Omit<SpeedDialInput, "userId">;
    onSuccess: () => void;
    disabled: boolean;
};

export default ({onSuccess, userId, data, disabled}: Props) => {
    const [isDialogOpen, setDialogOpen] = useState(false);

    return (
        <Fragment>
            <IconButton color="primary" onClick={() => setDialogOpen(true)} size="small" disabled={disabled}>
                <FontAwesomeIcon icon="pencil-alt" />
            </IconButton>
            {isDialogOpen && (
                <CreateUpdateDialog
                    onSuccess={() => onSuccess()}
                    isOpen={isDialogOpen}
                    close={() => setDialogOpen(false)}
                    userId={userId}
                    speedDialData={data}
                />
            )}
        </Fragment>
    );
};
